var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 45,
    viewBox: "0 0 51 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8295 34.0781C22.8295 34.7868 23.111 35.4664 23.6121 35.9674C24.1132 36.4685 24.7928 36.75 25.5014 36.75C26.21 36.75 26.8896 36.4685 27.3907 35.9674C27.8918 35.4664 28.1733 34.7868 28.1733 34.0781C28.1733 33.3695 27.8918 32.6899 27.3907 32.1888C26.8896 31.6878 26.21 31.4062 25.5014 31.4062C24.7928 31.4062 24.1132 31.6878 23.6121 32.1888C23.111 32.6899 22.8295 33.3695 22.8295 34.0781ZM23.7202 17.1562V27.3984C23.7202 27.6434 23.9206 27.8438 24.1655 27.8438H26.8373C27.0823 27.8438 27.2827 27.6434 27.2827 27.3984V17.1562C27.2827 16.9113 27.0823 16.7109 26.8373 16.7109H24.1655C23.9206 16.7109 23.7202 16.9113 23.7202 17.1562ZM50.1996 41.6484L27.0433 1.57031C26.6982 0.974707 26.1026 0.679688 25.5014 0.679688C24.9002 0.679688 24.2991 0.974707 23.9595 1.57031L0.803266 41.6484C0.118598 42.8396 0.975824 44.3203 2.34516 44.3203H48.6577C50.027 44.3203 50.8842 42.8396 50.1996 41.6484ZM6.58676 40.0954L25.5014 7.35381L44.4161 40.0954H6.58676Z",
    fill: "#0075FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTip);
export default __webpack_public_path__ + "static/media/tip.6e9f988a6aef2166af6ef8d8f9d9b8ce.svg";
export { ForwardRef as ReactComponent };